import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontDisplay, isMobileApp, StylesIndexInjections } from 'common-react';
import { zIndex as uiZIndex } from '../theme/constants';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    marginBottom: 24,
  },
  triggerButton: {
    width: 'fit-content',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0 16px',
  },
  tabsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 8,
  },
  panel: {
    width: '100%',
  },
  overTimePanel: {
    minHeight: 500,
  },
  structurePanel: {
    minHeight: 250,
  },
  modal: {
    background: theme.color.greys[0],
    padding: `0 0 ${theme.space.mobileNavHeight() + 96}px`,
    boxSizing: 'border-box',
  },
  modalHeader: {
    '& span': {
      font: fontDisplay('normal', theme.fontSize.xl, 36),
      margin: '16px'
    },
  },
  backBar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: uiZIndex.menuModalZIndex,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    background: theme.color.greys[0],
    borderTop: `1px solid ${theme.color.greys[15]}`,
    boxSizing: 'border-box',
    paddingBottom: isMobileApp() ? `calc(${theme.space.mobileBottomPadding()}px + 16px)` : 16,
  },
  backButton: {
    minWidth: 200,
  },
}), { name: 'PortfolioChartsToggleMobile', index: StylesIndexInjections.UI_MOLECULES });

